import React from 'react';
import { Modal, Form } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
  useModalState,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownResponsibleChange } from '../../api';
import { ShutdownField } from '../../../common/ui/ShutdownField';
import {
  fieldNames,
  changeModalWithInfoBodyStyle,
} from '../../../common/config';
import NotificationSendingAlert, {
  notificationSendingAlertMsgTypes,
} from '../../../../../shared/ui/NotificationSendingAlert/NotificationSendingAlert';

const ModalContainer = ({ form }) => {
  const { type, initialValues: shutdown = {} } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => dispatch({ type: modalActionTypes.resetModalData });

  const { change, loading } = useShutdownResponsibleChange();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const currentEntities = (shutdown.executors || []).map((entity) => ({
          id: entity.id,
        }));
        const entitiesFromForm = formValues[fieldNames.responsible].map(
          (id) => ({ id })
        );

        await change({
          shutdownId: shutdown.alertId,
          data: [...currentEntities, ...entitiesFromForm],
        });
        close();
      }
    });
  };

  return (
    <Modal
      visible={type === modalTypes.addShutdownResponsible}
      onCancel={close}
      onOk={handleSubmit}
      title="Добавить ответственных"
      destroyOnClose
      confirmLoading={loading}
      bodyStyle={changeModalWithInfoBodyStyle}
    >
      <NotificationSendingAlert
        messageType={notificationSendingAlertMsgTypes.worker}
      />
      <Form colon={false}>
        <ShutdownField
          name={fieldNames.responsible}
          form={form}
          initialValue={shutdown.executors?.map((item) => item.id)}
          editMode
          companyId={shutdown?.serviceCompany?.id}
        />
      </Form>
    </Modal>
  );
};

const ChangeModal = Form.create({ name: 'change_shutdown_executors' })(
  ModalContainer
);

export default ChangeModal;
